export default __webpack_public_path__ + "static/articulo1-2a4eac41d314fc024f8864007bdc6644.png";